
import React from 'react';
import { Editor } from '@tiptap/react';
import FormatButtons from './toolbar/FormatButtons';
import HeadingButtons from './toolbar/HeadingButtons';
import AlignmentButtons from './toolbar/AlignmentButtons';
import ListButtons from './toolbar/ListButtons';
import HistoryButtons from './toolbar/HistoryButtons';
import ColorButtons from './toolbar/ColorButtons';
import MediaButtons from './toolbar/MediaButtons';

interface MenuBarProps {
  editor: Editor | null;
  shopId?: string;
  organizationId?: string;
}

const MenuBar = ({ editor, shopId, organizationId }: MenuBarProps) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1a1a2e] p-1 flex flex-wrap gap-1 sticky top-0 z-10">
      <HistoryButtons editor={editor} />
      <FormatButtons editor={editor} />
      <HeadingButtons editor={editor} />
      <ListButtons editor={editor} />
      <AlignmentButtons editor={editor} />
      <ColorButtons editor={editor} />
      <MediaButtons editor={editor} shopId={shopId} organizationId={organizationId} />
    </div>
  );
};

export default MenuBar;
